import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

interface IProps {
    show: boolean
    hide: any
    title?: string
}

export default class NotificationModal extends React.Component<React.PropsWithChildren<IProps>> {
    public render() {
        return (
            <Modal className="notification-warning-modal" isOpen={this.props.show} toggle={this.props.hide}>
                <ModalHeader toggle={this.props.hide}>
                    {this.props.title && <img
                        className="notification-warning-icon"
                        src="/img/warning-filled.svg"
                        alt="Attention"
                    />}
                    <div className="text-blue-2 font-weight-medium">{this.props.title}</div>
                </ModalHeader>
                <ModalBody>
                    {this.props.children}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary btn-next" onClick={this.props.hide}>Ok, I understand</button>
                </ModalFooter>
            </Modal>
        );
    }
}
